import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LazyShareToFeed, LazyShareToMessenger } from '../lazy-components';
import { ShareErrorBoundary } from '../banners';
import { TrackingPropsContextWrapper } from '../contexts/tracking-props-context-wrapper';
import { Styled } from './share-views.styles';
export const ShareViews = ({ backendTrackingMetaData, entryPoint, inputHintClick = false, interactionTargetUrn, openWithShareTo, propChannel, propSocialInteractionId, propSourceType, onCancel, onError, onSuccess, url, verb, }) => (_jsx(ShareErrorBoundary, { children: _jsx(TrackingPropsContextWrapper, { backendTrackingMetaData,
        entryPoint,
        inputHintClick,
        interactionTargetUrn,
        propChannel,
        propSocialInteractionId,
        propSourceType, children: _jsxs(Styled.Grid, { children: [openWithShareTo === 'FEED' && (_jsx(LazyShareToFeed, { onCancel, onError, onSuccess, url, verb })), openWithShareTo === 'MESSENGER' && (_jsx(LazyShareToMessenger, { onCancel, onError, onSuccess, url }))] }) }) }));
//# sourceMappingURL=share-views.js.map